import DetailPostHogIPs from "../../../../contents/docs/integrate/_snippets/details/posthog-ips.mdx";
import * as React from 'react';
export default {
  DetailPostHogIPs,
  React
};